import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '../../../create-mock-endpoint';

import { WalletUserBalanceDetailResponse } from '@/repositories/generated';

const response: WalletUserBalanceDetailResponse = {
  lastUpdatedAt: '2021-08-10T00:00:00+09:00',
  valueBalance: {
    valueTotal: 400,
    bonusValue: {
      balanceTotal: 300,
      balanceExpiresAt: [
        {
          balance: 100,
          expiresAt: '2021-01-01T00:00:00',
        },
        {
          balance: 200,
        },
      ],
    },
    fundsTransferValue: {
      balanceTotal: 100,
      balanceExpiresAt: [
        {
          balance: 40,
          expiresAt: '2021-01-03T00:00:00',
        },
        {
          balance: 30,
          expiresAt: undefined,
        },
        {
          balance: 30,
          expiresAt: '9999-12-31T00:00:00',
        },
      ],
    },
    prepaidValue: {
      balanceTotal: 0,
      balanceExpiresAt: undefined,
    },
  },
  pointBalance: {
    pointTotal: -300,
    basicPoint: {
      balanceTotal: -300,
      balanceExpiresAt: [
        {
          balance: 100,
          expiresAt: '2021-01-01T00:00:00',
        },
        {
          balance: -400,
        },
      ],
    },
    bonusPoint: {
      balanceTotal: 0,
      balanceExpiresAt: undefined,
    },
  },
  scheduleBalance: {
    bonusValue: {
      balanceTotal: 300,
      grantSchedule: [
        {
          amount: 100,
          scheduleDateTime: '2021-01-01T00:00:00+09:00',
        },
        {
          amount: 200,
          scheduleDateTime: '2021-01-02T00:00:00+09:00',
        },
      ],
    },
    basicPoint: {
      balanceTotal: 300,
      grantSchedule: [
        {
          amount: 100,
          scheduleDateTime: '2021-01-01T00:00:00+09:00',
        },
        {
          amount: 200,
          scheduleDateTime: '2021-01-02T00:00:00+09:00',
        },
      ],
    },
    bonusPoint: {
      balanceTotal: 0,
      grantSchedule: undefined,
    },
  },
};

export const walletUserBalanceDetail = http.get(
  createMockEndpoint('/wallet_user/balance/:walletUserId/:paymentMethodId/:walletServiceId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
